import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

export const ColorPickerTemplateStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "color-picker-template",
})`
  position: relative;
  width: 100%;
  overflow: visible;
`;

export const ColorSwatchButton = styled.button.attrs<IStyledAttributes>({
  type: "button",
  [DATA_E2E_KEY]: "color-picker-swatch",
})<{ $color?: string; $disabled?: boolean }>`
  width: 28px;
  height: 28px;
  border-radius: 4px;
  border: 1px solid ${rydeColors.whiteButtonBorder};
  background-color: ${({ $color }) => $color || "transparent"};
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  padding: 0;
  background-image: ${({ $color }) =>
    $color
      ? "none"
      : `linear-gradient(45deg, ${rydeColors.lightGrey} 25%, transparent 25%),
         linear-gradient(-45deg, ${rydeColors.lightGrey} 25%, transparent 25%),
         linear-gradient(45deg, transparent 75%, ${rydeColors.lightGrey} 75%),
         linear-gradient(-45deg, transparent 75%, ${rydeColors.lightGrey} 75%)`};
  background-size: 8px 8px;
  background-position:
    0 0,
    0 4px,
    4px -4px,
    -4px 0;
  transition: border-color 0.2s ease;

  &:hover:not(:disabled) {
    border-color: ${rydeColors.focusedControl};
  }

  &:focus-visible {
    outline: 2px solid ${rydeColors.focusedControl};
    outline-offset: 2px;
  }
`;

export const ColorPickerPopoverContent = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "color-picker-popover",
})`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  background-color: ${rydeColors.white};
  border: 1px solid ${rydeColors.lightGreyBorder};
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);

  .react-colorful {
    width: 220px;
    height: 200px;
  }

  .react-colorful__saturation {
    border-radius: 6px 6px 0 0;
  }

  .react-colorful__hue {
    border-radius: 0 0 6px 6px;
    height: 16px;
    margin-top: 8px;
  }

  .react-colorful__pointer {
    width: 16px;
    height: 16px;
  }
`;
